import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/adduser.svg'
import _imports_2 from '@/assets/icons/add.svg'
import _imports_3 from '@/assets/icons/adddisabled.svg'
import _imports_4 from '@/assets/icons/addaddonenabled.svg'
import _imports_5 from '@/assets/icons/addaddondisabled.svg'
import _imports_6 from '@/assets/icons/addontooltipwarn.svg'
import _imports_7 from '@/assets/icons/deladdonenabled.svg'
import _imports_8 from '@/assets/icons/deladdondisabled.svg'
import _imports_9 from '@/assets/icons/delete.svg'
import _imports_10 from '@/assets/icons/deletedisabled.svg'
import _imports_11 from '@/assets/icons/deletedisabledwarning.svg'


const _hoisted_1 = { class: "controltextstyle" }
const _hoisted_2 = {
  key: 0,
  class: "font-bold-24"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "utils" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"40px"},
  alt: "adduserimage",
  title: "Add User"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  src: _imports_2,
  style: {"width":"40px"},
  alt: "addproductimage",
  title: "Add Product"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_3,
  style: {"width":"40px"},
  alt: "addproductdisabledimage",
  title: "Add Product"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_4,
  style: {"width":"40px"},
  alt: "addaddonenabledimage",
  title: "Assign Add-on"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_5,
  style: {"width":"40px"},
  alt: "addaddondisabledimage",
  title: "Assign Add-on"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"width":"40px"},
  alt: "addonrestrictedImage"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  src: _imports_7,
  style: {"width":"40px"},
  alt: "deladdonenabledimage",
  title: "Remove Add-on"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_8,
  style: {"width":"40px"},
  alt: "deladdondisabledimage",
  title: "Remove Add-on"
}
const _hoisted_15 = {
  key: 2,
  src: _imports_8,
  style: {"width":"40px"},
  alt: "deladdondisabledimage",
  title: "Remove Add-on"
}
const _hoisted_16 = {
  key: 0,
  src: _imports_9,
  style: {"width":"40px"},
  alt: "deleteuserimage",
  title: "Delete User"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_10,
  style: {"width":"40px"},
  alt: "deletedisabledimage",
  title: "Delete User"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  style: {"width":"40px"},
  alt: "deletedisabledimage",
  title: "Delete User"
}, null, -1)
const _hoisted_19 = { class: "text-div font-regular-16" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "All user data and licenses will be permanently removed.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "This action may not be undone.", -1)
const _hoisted_23 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_AssignProductsModal = _resolveComponent("AssignProductsModal")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!
  const _component_RemoveAddonsModal = _resolveComponent("RemoveAddonsModal")!
  const _component_AssignMultipleAddonsModal = _resolveComponent("AssignMultipleAddonsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.displayForUsers)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_2, "Available Users"))
        : _createCommentVNode("", true),
      (!_ctx.displayForUsers)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              id: "usersearch",
              modelValue: _ctx.usrSearchVal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usrSearchVal) = $event)),
              placeholder: "Search",
              type: "search",
              debounce: 1000,
              class: "rightmargin inpstyle"
            }, {
              suffix: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.displayForUsers)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              plain: "",
              class: "delbtn",
              onClick: _ctx.addUserHandler,
              id: "addUser"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.displayForUsers)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              plain: "",
              class: "delbtn",
              onClick: _ctx.showAddProducts,
              id: "assignproduct",
              disabled: !_ctx.enablebuttons
            }, {
              default: _withCtx(() => [
                (_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : _createCommentVNode("", true),
                (!_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.showOptions && !_ctx.disableAssignAddon)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              plain: "",
              class: "delbtn",
              onClick: _ctx.assignAddon,
              id: "addignaddon",
              disabled: !_ctx.enablebuttons
            }, {
              default: _withCtx(() => [
                (_ctx.enablebuttons && !_ctx.disableAssignAddon)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                  : _createCommentVNode("", true),
                (!_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.showOptions && _ctx.disableAssignAddon)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 4,
              class: "box-item",
              effect: "dark",
              placement: "top"
            }, {
              content: _withCtx(() => [
                _createTextVNode(" Some selected users do not have any or common "),
                _hoisted_11,
                _createTextVNode("products assigned . ")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "delbtn",
                  id: "addignaddondisabled",
                  disabled: _ctx.disableAssignAddon
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 5,
              plain: "",
              class: "delbtn",
              onClick: _ctx.removeAddon,
              id: "removeaddon",
              disabled: !_ctx.enablebuttons && _ctx.DisableDeleteAddon
            }, {
              default: _withCtx(() => [
                (_ctx.enablebuttons && !_ctx.DisableDeleteAddon)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : _createCommentVNode("", true),
                (_ctx.enablebuttons && _ctx.DisableDeleteAddon)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                  : _createCommentVNode("", true),
                (!_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.showOptions && !_ctx.disableDelete)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 6,
              plain: "",
              class: "delbtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteDailogue = true)),
              id: "deleteuser",
              disabled: !_ctx.enablebuttons
            }, {
              default: _withCtx(() => [
                (_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                  : _createCommentVNode("", true),
                (!_ctx.enablebuttons)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.showOptions && _ctx.disableDelete)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 7,
              class: "box-item",
              effect: "dark",
              placement: "top"
            }, {
              content: _withCtx(() => [
                _createTextVNode(" Some selected users have borrowed licenses. ")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "delbtn",
                  id: "deleteUserWarn",
                  disabled: _ctx.disableAssignAddon
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "Delete Users",
      modelValue: _ctx.showDeleteDailogue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDeleteDailogue) = $event)),
      width: "35%",
      top: "25vh",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            id: "deleteusercancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteDailogue = false)),
            round: "",
            class: "cancelbtn",
            variant: "outline-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteUser,
            round: "",
            class: "deletebutton",
            id: "deleteuserconfirm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirm ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.usersSelectedCount), 1),
            _createTextVNode(" Users selected ")
          ]),
          _hoisted_20,
          _hoisted_21,
          _hoisted_22
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAddprod,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAddprod) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignProductsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAdduser,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAdduser) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddUserModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showRemoveAddon,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showRemoveAddon) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RemoveAddonsModal)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showAssignAddon,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showAssignAddon) = $event)),
      direction: "rtl",
      size: "40%",
      "destroy-on-close": "",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      wrapperClosable: false,
      "before-close": _ctx.closeModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssignMultipleAddonsModal, { intersectionList: _ctx.productsIntersectionList }, null, 8, ["intersectionList"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}